import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@styles/tailwind.css';
import '@styles/global.scss';

// Formio file-provider registration was previously called here eagerly, which
// pulled @formio/js into the app-boot import graph and forced a ~1.6 MB chunk
// fetch on every page (even /w/home). It now self-registers lazily — every
// Form/FormBuilder lazy-loader chains through `loadFormioReact()` which awaits
// `registerFormioFileProvider()` before resolving. Module-level guards in
// `formioFileProvider.ts` make the registration idempotent under concurrent
// loads.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Remove the static bootstrap loader (index.html #app-loader) once React has
// mounted. GlobalLoader takes over for the session-fetch window — both render
// the identical mark, so the handoff is visually seamless.
requestAnimationFrame(() => {
  document.getElementById('app-loader')?.remove();
});
